import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { GSDevTools } from 'gsap/GSDevTools'
import axios from 'axios'
const prod = process.env.NODE_ENV === 'production'
const lib = require('../library')

export default class StacksLoad {
  constructor(el) {
    this.el = el
    this.window = window
    this.setVars()
    this.init()
  }

  setVars() {
    this.body = document.querySelector('body')
    this.resultButton = this.el.querySelector('button')
    this.ease = 'Power1.easeInOut'
    this.resultContainer = document.querySelector('[data-stacks-target]')
    this.entryId = this.resultButton.dataset.stacksId
    this.entrySlug = this.resultButton.dataset.stacksSlug
    this.url = this.resultButton.dataset.stacksUrl
    this.baseUrl = location.href
    if (this.resultsContainer) {
      this.source = this.resultContainer.dataset.stacksSource
    } else {
      this.source = null
    }
  }

  init() {
    if (this.source === 'preloaded') {
      this.resultContainer.classList.add('s-ready')
      this.setOpenVars()
    } else if (this.resultContainer) {
      this.resultContainer.classList.add('hidden', 's-ready')
    }
    this.resultButton.addEventListener('click', this.handleResultsLoad)
  }

  // sets watch after the stack is open
  setOpenVars() {
    this.resultContainer = document.querySelector('[data-stacks-target]')
    this.close = this.resultContainer.querySelectorAll(
      '[data-stacks-close]',
    )

    this.close.forEach((closeButton) =>
      this.handleClose(closeButton))
  }

  handleClose(button) {
    button.addEventListener('click', this.closeStack)
  }

  closeStack = () => {
    this.animateOut(this)
  }

  // Ajax Request To Stacks Page
  handleResultsLoad = () => {
    lib.buttonStates(this.resultButton, 'loading')

    let requestUrl = this.url
    if (this.entryId) {
      requestUrl += this.entryId
    }

    const instance = axios.create()
    instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    instance
      .get(requestUrl, { timeout: 7000 })
      .then(({ data }) => {
        this.appendResults(data)
      })
      .catch((error) => {
        lib.buttonStates(this.resultButton, 'error')
        if (prod) {
        } else {
          lib.logError('Stack failed to AJAX load', error)
        }
      })
  }

  appendResults = (body) => {
    if (!this.resultContainer) {
      console.log('no results')
    }
    this.resultContainer.innerHTML = body
    lib.buttonStates(this.resultButton, 'ready')

    // @TODO: Doesn't handle if the URL has an existing parameter. Need to expand to enable that
    history.pushState(
      { id: this.entryId },
      'testing',
      `?show=${this.entrySlug}`,
    )
    this.animateIn()
    this.setOpenVars()
    // moduleElements();
  }

  // Animation and Effects
  animateIn() {
    this.resultContainer.classList.remove('hidden')
    this.body.classList.add('s-stacks-open')

    this.stacksBody = this.resultContainer.querySelectorAll(
      '[data-stack-body]',
    )
    this.stacksScreen = this.resultContainer.querySelectorAll(
      '[data-stack-screen]',
    )
    const tlStack = gsap.timeline({
      defaults: { duration: 0.5, opacity: 0, ease: this.ease },
    })
    // Stats
    tlStack
      .from(this.stacksScreen, {
        opacity: 0,
      })
      .from(
        this.stacksBody,
        {
          x: 30,
          opacity: 0,
        },
        '<',
      )
    // lib.reInitDeferModules("GridBg");
  }

  animateOut() {
    const tlStackOut = gsap.timeline({
      defaults: { duration: 0.3, opacity: 0, ease: this.ease },
    })
    // Stats
    tlStackOut
      .to(this.stacksScreen, {
        opacity: 0,
      })
      .to(
        this.stacksBody,
        {
          x: 30,
          opacity: 0,
        },
        '<',
      )

    tlStackOut.eventCallback('onComplete', this.destroyStack)
  }

  destroyStack = () => {
    lib.removeParamLocation('show')
    this.body.classList.remove('s-stacks-open')
    this.resultContainer.innerHTML = ''
    this.resultContainer.classList.add('hidden')
    lib.buttonStates(this.resultButton, 'ready')
  }
}
